<template>
<div class="chapter">
<div class="inner_page">
<p class="prect" id="contents"><a id="pVIII"></a><a id="pIX"></a>CONTENTS</p>
<p class="contents-"><a href="#/preface.htm#pre">Preface</a></p>
<p class="contents--"><a href="#/introduction.htm#intro">Introduction</a></p>
<p class="contents-pt"><a href="#/part_01.htm#part1">PART ONE: E PLURIBUS INC.</a></p>
<p class="contents-ct"><a href="#/chapter_01.htm#chap1"><span class="contentblock"><b>1</b> </span>The Danger and Necessity of Banks</a></p>
<p class="contents-ct"><a href="#/chapter_02.htm#chap2"><span class="contentblock"><b>2</b> </span>A Cheat upon Somebody</a></p>
<p class="contents-ct"><a href="#/chapter_03.htm#chap3"><span class="contentblock"><b>3</b> </span>Inc.</a></p>
<p class="contents-ct"><a href="#/chapter_04.htm#chap4"><span class="contentblock"><b>4</b> </span>The Civil War Tames Currency</a></p>
<p class="contents-ct"><a href="#/chapter_05.htm#chap5"><span class="contentblock"><b>5</b> </span>Sunshine Charlie</a></p>
<p class="contents-ct"><a href="#/chapter_06.htm#chap6"><span class="contentblock"><b>6</b> </span>Radio, Rayon, and Retail Credit</a></p>
<p class="contents-ct"><a href="#/chapter_07.htm#chap7"><span class="contentblock"><b>7</b> </span>If It Seems Too Good to Be True . . .</a></p>
<p class="contents-ct"><a href="#/chapter_08.htm#chap8"><span class="contentblock"><b>8</b> </span>Crash and Contagion</a></p>
<p class="contents-ct"><a href="#/chapter_09.htm#chap9"><span class="contentblock"><b>9</b> </span>Tickled with Poverty</a></p>
<p class="contents-ct"><a href="#/chapter_10.htm#chap10"><span class="contentblock"><b>10</b> </span>Moral Hazard</a></p>
<p class="contents-pt"><a id="pX"></a><a href="#/part_02.htm#part2">PART TWO: A WONDERFUL LIFE: SOCIALISM FOR THE RICH</a></p>
<p class="contents-ct"><a href="#/chapter_11.htm#chap11"><span class="contentblock"><b>11</b> </span>Zombie Banks</a></p>
<p class="contents-ct"><a href="#/chapter_12.htm#chap12"><span class="contentblock"><b>12</b> </span>The American Home: Safeguard of American Liberties</a></p>
<p class="contents-ct"><a href="#/chapter_13.htm#chap13"><span class="contentblock"><b>13</b> </span>Financial Cocaine</a></p>
<p class="contents-ct"><a href="#/chapter_14.htm#chap14"><span class="contentblock"><b>14</b> </span>Cover-Up and Bailout</a></p>
<p class="contents-ct"><a href="#/chapter_15.htm#chap15"><span class="contentblock"><b>15</b> </span>Russia Defaults</a></p>
<p class="contents-ct"><a href="#/chapter_16.htm#chap16"><span class="contentblock"><b>16</b> </span>The Committee to Save the World</a></p>
<p class="contents-ct"><a href="#/chapter_17.htm#chap17"><span class="contentblock"><b>17</b> </span>Dysfunctional Oversight</a></p>
<p class="contents-ct"><a href="#/chapter_18.htm#chap18"><span class="contentblock"><b>18</b> </span>Enron: The Emperor’s New Clothes</a></p>
<p class="contents-pt"><a href="#/part_03.htm#part3">PART THREE: ILL-GOTTEN GAIN: BOOM, BUST, AND THE GREAT RECESSION</a></p>
<p class="contents-ct"><a href="#/chapter_19.htm#chap19"><span class="contentblock"><b>19</b> </span>Tent City</a></p>
<p class="contents-ct"><a href="#/chapter_20.htm#chap20"><span class="contentblock"><b>20</b> </span>Financial Magic</a></p>
<p class="contents-ct"><a href="#/chapter_21.htm#chap21"><span class="contentblock"><b>21</b> </span>The Subprime Prisoner’s Dilemma</a></p>
<p class="contents-ct"><a href="#/chapter_22.htm#chap22"><span class="contentblock"><b>22</b> </span>Feds Tell States: Shut Up, Sit Down</a></p>
<p class="contents-ct"><a href="#/chapter_23.htm#chap23"><span class="contentblock"><b>23</b> </span>A Number Out of the Air</a></p>
<p class="contents-pt"><a href="#/part_04.htm#part4">PART FOUR: COCKROACHES IN THE KITCHEN</a></p>
<p class="contents-ct"><a href="#/chapter_24.htm#chap24"><span class="contentblock"><b>24</b> </span>Fake Accounts</a></p>
<p class="contents-ct"><a href="#/chapter_25.htm#chap25"><span class="contentblock"><b>25</b> </span>Who Should Own a Bank</a></p>
<p class="contents--"><a href="#/notes.htm#notes">Notes</a></p>
<p class="contents"><a href="#/bibliography.htm#bib">Bibliography</a></p>
<p class="contents"><a href="#/index.htm#index">Index</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1edd6d24